import React, { ReactNode } from "react";
import { matchPath, Navigate, useLocation, useParams } from "react-router-dom";

interface RoleProtectedProps {
  children: ReactNode;
  assignedRoutes: { path: string }[];
}

const RoleProtected: React.FC<RoleProtectedProps> = ({
  children,
  assignedRoutes,
}) => {
  const location = useLocation();
  const isRouteAccessible = assignedRoutes.some(
    (route) => matchPath(route.path, location.pathname)
  );
  
  
  // Check if the current route is in assigned routes
  if (!isRouteAccessible) {
    return <Navigate to="/pages-404" />;
  }

  return <>{children}</>;
};

export default RoleProtected;
